import classNames from 'classnames';
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import styles from './MapRender.module.scss';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

/**
 * MapRender
 *
 * @return {JSX.Element}
 */
const MapRender = ({ className, children, ...rest }) => {
  return (
    <MapContainer
      className={classNames(
        styles.MapRender,
        className,
        `${MapRender.displayName}`
      )}
      center={[51.505, -0.09]}
      // latitude: 40.7127753,
      // longitude: -74.009221,
      // center={{ lat: 40.7127753, lng: -74.009221 }}
      zoom={12}
      scrollWheelZoom={false}
      {...rest}
    >
      {/*<TileLayer*/}
      {/*  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'*/}
      {/*  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
      {/*/>*/}
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://api.mapbox.com/styles/v1/lxblink/ckrcxrikx1yij17nyq64zm43w/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibHhibGluayIsImEiOiJja3JjeDJzYTcwOG1uMzFvZWY4eHZ4bHduIn0.lhOXJ5jFf23ZzL_mzQnbWg"
      />
      {children}
    </MapContainer>
  );
};

MapRender.displayName = 'MapRender';

export default MapRender;
